import { render, staticRenderFns } from "./Main.Header.vue?vue&type=template&id=4b0f1010&scoped=true&"
import script from "./Main.Header.vue?vue&type=script&lang=js&"
export * from "./Main.Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0f1010",
  null
  
)

export default component.exports